import React from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, TextField, Button, Autocomplete, Grid, FormGroup, FormControlLabel, Container } from '@mui/material';
import UpdateIcon from '@mui/icons-material/Update';
import AddIcon from '@mui/icons-material/Add';

import Loading from '../../utils/Loading';
import Multiselect from '../../utils/MultiSelect'

function FleetForm ({action, isLoading, vehicle, onRegistrationChange, onModelChange, onLocationChange, onForRentalChange, onForTransfersChange, onForChauffeurChange, onPlaceholderChange, handleSubmit}) {
    const { locations, models } = useSelector((state) => state.fleet);

    //Autocomplete settings
    const getModelOptionLabel = (option) => {
        if (option === null) {
            return null
        }
        return `${option.vehicle_make} ${option.vehicle_model}`
    };
    const isOptionEqualToValue = (option, value) => {
        if (option === null || value === null) {
            return null;
        }
        return value.id === option.id;
    };

    return (
        <Container>
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2} align='center'>
                <Grid item xs={12} md={4}>
                    <TextField label='Registration' value={vehicle.registration} required onChange={(e) => onRegistrationChange(e.target.value)} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Autocomplete 
                        value={vehicle.model}
                        onChange={(event, newValue) => onModelChange(newValue)}
                        options={models}
                        getOptionLabel={getModelOptionLabel}
                        isOptionEqualToValue={isOptionEqualToValue}
                        renderInput={(params) => <TextField {...params} label='Model' required />}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Multiselect 
                        inputLabel={'Locations'}
                        values={locations}
                        valuesState={vehicle.locations}
                        labelFunction={(value) => {return value.location}}
                        onChange={onLocationChange}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={vehicle.for_rental} onChange={(e) => onForRentalChange(e.target.checked)} />} label="For rental" />
                    </FormGroup>
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={vehicle.for_transfers} onChange={(e) => onForTransfersChange(e.target.checked)} />} label="For transfers" />
                    </FormGroup>
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={vehicle.for_chauffeur} onChange={(e) => onForChauffeurChange(e.target.checked)} />} label="For chauffeur" />
                    </FormGroup>
                </Grid>
                <Grid item xs={12}>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={vehicle.is_placeholder} onChange={(e) => onPlaceholderChange(e.target.checked)} />} label="Is placeholder only" />
                    </FormGroup>
                </Grid>
                <Grid item xs={12}>
                    {action === 'update' ? (
                        <Button type='submit' variant='contained' endIcon={<UpdateIcon />}>
                            {isLoading ? <Loading /> : 'Update'}
                        </Button>
                    ) : (
                        <Button type='submit' variant='contained' endIcon={<AddIcon />}>
                            {isLoading ? <Loading /> : 'Create'}
                        </Button>
                    )}
                </Grid>
            </Grid>
        </form>
        </Container>
    )
}

export default FleetForm